/**
 * 文件下载
 * @param {Object} blob 文件数据
 * @param {String} fileName 文件名
 */
export function download(blob, fileName) {
    if (blob.size > 0) {
        let downloadElement = document.createElement('a')
        let href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = fileName
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
        return true
    } else {
        return false
    }
}



// WEBPACK FOOTER //
// ./src/libs/utils.js